const Url = "https://apimediateca.trafficlight.mx/api/"
export {Url};
